module.exports = __webpack_public_path__ + "media/hallBgm.a46dd660.mp3";